import { z, ZodSchema } from "zod";
import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { formatFirebaseError } from "@core/services/api/formatFirebaseError";
import { updateUserPassword } from "../utils/updateUserPassword";
import { UpdatePasswordFormData } from "../components/UpdatePasswordFormBase";

export type UseUpdatePasswordMutationArgs = {
  /** Callback when mutation succeeds */
  onSuccess?: (data: any) => void;
  /** Zod schema for validation */
  schema: ZodSchema;
  /** Current user email for re-authentication */
  currentEmail: string;
};

export type UseUpdatePasswordMutationReturn = UseMutationResult<
  any,
  Error,
  UpdatePasswordFormData
>;

/**
 * Hook for password update mutation
 * Handles Firebase re-authentication and password update
 */
export function useUpdatePasswordMutation({
  onSuccess,
  schema,
  currentEmail,
}: UseUpdatePasswordMutationArgs): UseUpdatePasswordMutationReturn {
  return useMutation({
    mutationFn: async (data: z.infer<typeof schema>) => {
      return updateUserPassword({
        email: currentEmail,
        oldPassword: data.currentPassword,
        newPassword: data.password,
      });
    },
    onError: (error: Error) => {
      throw new Error(formatFirebaseError(error.message));
    },
    onSuccess: async (data) => {
      onSuccess?.(data);
    },
  });
}

export default useUpdatePasswordMutation;

